import React from "react";
import "./style.css";

const Scrollbar: React.FC = () => {
  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="col-lg-12">
      <div className="header-menu">
        <ul className="smothscroll">
          <li>
            <button
              onClick={handleClick}
              aria-label="Scroll to top"
              className="scroll-to-top"
              style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
            >
              <i className="ti-arrow-up" aria-hidden="true"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Scrollbar;
